export default __webpack_public_path__ + "static/media/devastation.65c370fc.png";